import { render, staticRenderFns } from "./CButtons_download2.vue?vue&type=template&id=05a85fe6&scoped=true"
import script from "./CButtons_download2.vue?vue&type=script&lang=js"
export * from "./CButtons_download2.vue?vue&type=script&lang=js"
import style0 from "./CButtons_download2.vue?vue&type=style&index=0&id=05a85fe6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a85fe6",
  null
  
)

export default component.exports